import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

import { INonInventoryData, IGetManyNonInventoryParams } from "./interfaces";

export const SLICE_NAME = "nonInventory";

export type InitialStateType = {
  data: INonInventoryData;
  params: IGetManyNonInventoryParams;
};

type NonInventoryDataPayload = {
  data: INonInventoryData;
};

type GetManyNonInventoryParamsPayload = {
  params: IGetManyNonInventoryParams;
};

export type CaseReducers<State> = {
  setParams: CaseReducer<State, PayloadAction<GetManyNonInventoryParamsPayload>>;
  setNonInventory: CaseReducer<State, PayloadAction<NonInventoryDataPayload>>;
};
